export default "__VITE_ASSET__aJ__vK7x__"